export default __webpack_public_path__ + "static/media/vg-logo.9b602b42.png";